import { createContext, useContext, useEffect, useState } from 'react';
import {useLocation} from "react-router-dom";
import Swal from "sweetalert2";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);

    useEffect(() => {
        const version = queryParams.get('version');
        if (version != null) {
            localStorage.setItem("web_version", version);
        }
    }, [queryParams]);

    const [user, setUser] = useState(null);
    const [accessToken, setAccessToken] = useState(null);

    // Verifica se há usuário salvo no localStorage
    useEffect(() => {
        const storedUser = localStorage.getItem('authUser');
        const storedAccessToken = localStorage.getItem("accessToken");

        if (storedUser) {
            setUser(JSON.parse(storedUser));
        }

        if (storedAccessToken) {
            setAccessToken(accessToken);
        }
    }, []);

    const login = (userData, accessToken) => {
        localStorage.setItem('authUser', JSON.stringify(userData));
        localStorage.setItem('accessToken', accessToken);
        setUser(userData);
        setAccessToken(accessToken);
    };

    const logout = () => {
        localStorage.removeItem('authUser');
        localStorage.removeItem("accessToken");

        setUser(null);
        setAccessToken(null);
    };

    const updateUserData = (newUserData) => {
        setUser(newUserData);
    };

    const isAuthenticated = !!user;

    return (
        <AuthContext.Provider value={{ user, isAuthenticated, login, logout, updateUserData }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error('useAuth deve ser usado dentro de um AuthProvider');
    }
    return context;
};
